import { styled } from "@mui/material/styles";
import AccordionSummary, {
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import Accordion from "@mui/material/Accordion";

import AccordionDetails from "@mui/material/AccordionDetails";
import { PlainButton } from "components/button/plain";

export const TitleContainer = styled("div", {
  label: "title-container",
})`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    gap: 0;
    flex-wrap: wrap;
  }
`;

export const SeeMoreOrLessButton = styled(PlainButton, {
  label: "see-more-or-less-button",
})`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.color.primary.main};
  vertical-align: baseline;
  margin-left: ${({ theme }) => theme.spacing(1)};
`;

export const TopicDescription = styled(AccordionDetails, {
  label: "topic-description",
})`
  font-size: 16px;
  line-height: ${({ theme }) => theme.spacing(3)};
  font-weight: 400;
  color: ${({ theme }) => theme.palette.color.gray[50]};

  padding: ${({ theme }) => theme.spacing(0, 0, 1, 5)};

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  max-width: 60%;
  width: fit-content;

  border: none !important;
  &::before {
    display: none !important; /* Removes MUI's default pseudo-element */
    content: none !important;
  }
`;

export const TopicsTitle = styled("div", { label: "topics-title" })`
  color: ${({ theme }) => theme.palette.color.gray[50]};
  font-size: 20px;
  font-weight: 500;
  line-height: 1.25;
  display: flex;

  ${({ theme }) => theme.breakpoints.down("md")} {
    color: ${({ theme }) => theme.palette.color.primary.main};
    font-size: 18px;
    line-height: ${({ theme }) => theme.spacing(3)};
    padding-top: ${({ theme }) => theme.spacing(1.75)};
    padding-bottom: ${({ theme }) => theme.spacing(1)};
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ItemTitle = styled(AccordionSummary, {
  label: "item-title",
})`
  color: ${({ theme }) => theme.palette.color.gray[10]};
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
  display: flex;
  flex-direction: row-reverse;
  align-items: baseline;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing(1.25)};
  padding-left: ${({ theme }) => theme.spacing(1)};
  padding-top: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-left: 0;
    padding-top: 0;
  }

  &[aria-disabled="true"] {
    opacity: 1;
    color: ${({ theme }) => theme.palette.color.gray[80]};
  }

  .${accordionSummaryClasses.expandIconWrapper} {
    color: ${({ theme }) => theme.palette.color.gray[80]};
  }

  .${accordionSummaryClasses.content} {
    display: flex;
    flex-grow: 1;
    align-items: flex-start;
    margin: 0;
  }

  border: none !important;
  &::before {
    display: none !important; /* Removes MUI's default pseudo-element */
    content: none !important;
  }
`;

export const TitleMain = styled("div", {
  label: "title-main",
})`
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  line-height: ${({ theme }) => theme.spacing(3.75)};
  color: ${({ theme }) => theme.palette.color.text.primary};
  word-break: break-word;
  overflow-wrap: break-word;
  flex: 6.5;

  &.disabled {
    color: ${({ theme }) => theme.palette.color.gray[80]};
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-weight: 400;
    font-size: 16px;
    line-height: ${({ theme }) => theme.spacing(3)};
  }
`;

export const TitleSecondary = styled("div", {
  label: "title-secondary",
})`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.color.primary.main};
  text-align: left;
  line-height: ${({ theme }) => theme.spacing(3)};
  flex: 3.5;

  &.disabled {
    color: ${({ theme }) => theme.palette.color.gray[80]};
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-weight: 400;
    font-size: 16px;
    line-height: ${({ theme }) => theme.spacing(3)};
    padding-top: 0;
  }
`;

export const TopicItemAccordion = styled(Accordion, {
  label: "topic-item-accordion",
})`
  ${({ theme }) => theme.breakpoints.down("md")} {
    border-bottom: 1px solid ${({ theme }) => theme.palette.color.gray[90]};
    padding: ${({ theme }) => theme.spacing(1, 0)};

    :last-of-type {
      border-bottom: none;
      padding-bottom: ${({ theme }) => theme.spacing(2)};
    }
  }
  &::before {
    display: none;
    content: none;
  }
`;

export const OpenPopup = styled(PlainButton, {
  label: "open-popup-button",
})`
  border-radius: 50%;
  display: flex;
  width: ${({ theme }) => theme.spacing(3)};
  height: ${({ theme }) => theme.spacing(3)};
  border-radius: 50%;
  transition: ${({ theme }) => theme.transitions.create("background")};
  border: 1px solid ${({ theme }) => theme.palette.color.primary[90]};
  margin-left: ${({ theme }) => theme.spacing(1)};
  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }
`;
